module.exports = __webpack_public_path__ + "static/media/materialNetworkLogoCentered-2x.5d0c72a4.png";